import React,{useEffect,useState} from 'react';
import {ListGroup} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {useAuth} from '../auth/AuthContext';
import {authFetch} from '../utils/authFetch';
export default function DistributionReportsLink(){
 const {user}=useAuth()||{};
 const tenant=localStorage.getItem('active_tenant');
 const permitted=!!(user?.is_superuser||['RAPOARTE_READ','IESIRE_READ','STOC_READ','NC_READ','ALL_BRANCHES'].every(p=>user?.perms?.includes(p)));
 const [enabled,setEnabled]=useState(false);
 useEffect(()=>{
  let active=true;setEnabled(false);
  const refresh=()=>{setEnabled(false);if(permitted)authFetch('/company-modules').then(r=>{if(active)setEnabled(r.erp_enabled&&r.app_variant==='STANDARD');}).catch(()=>{});};
  refresh();window.addEventListener('company-modules-changed',refresh);
  return()=>{active=false;window.removeEventListener('company-modules-changed',refresh);};
 },[permitted,tenant]);
 return permitted&&enabled?<ListGroup.Item action as={Link} to="/rapoarte/distributie" className="py-3 px-4 border-0">Rapoarte distribuție</ListGroup.Item>:null;
}
